import { defineMessages } from 'react-intl';

export const errorsInInterCompany = defineMessages({
  cashInBank: {
    defaultMessage:
      'Cash companies have failed to load. Please retry in a few moments. If issue persists, please contact CDK Support.',
    description:
      'Error message for Cash In Bank Inter Company when the API call fails'
  },
  errorFromAPI: {
    defaultMessage: '{APIError}',
    description: 'Error message received from the response for InterCompany'
  }
});
